import {FC, useEffect, useState} from 'react';
import { useRecoilValue } from 'recoil';
import sortBy from 'lodash/sortBy';
import { Props } from './type';
import ChapterDetails from './components/ChapterDetails';
import { Chapter } from '@/components/tour/game/OpenGameBook/components/ChapterDetails/type';
import { Root, Header, List } from '@/components/tour/game/OpenGameBook/styled';
import Icon from '@/units/Icon';
import { translationDataState } from '../../../../store';
import { BannerHorizontalViewOnly } from '../BannerHorizontalViewOnly/BannerHorizontalViewOnly';

export const OpenGameBook: FC<Props> = ({ book, show, unlockedChapterIds, onClose, moveToSweep }) => {
  if (!show) return null;

  const translation = useRecoilValue(translationDataState);

  const { backgroundColor, backgroundOpacity, textColor, buttonColor, chapterLocked } = book;

  const [activeData, setActiveData] = useState<Chapter>();

  const isChapterLocked = (chapterId: number) => {
    if (!chapterLocked) return false;
    return !unlockedChapterIds.includes(chapterId);
  };

  const openChapter = (chapterId: number) => {
    let data;

    if (chapterId === 0) {
      data = {
        title: translation?.experienceCover || 'Cover',
        description: book.description,
        url: book.img ? `${process.env.REACT_APP_AWS}/games/${book.gameId}/book/${book.id}/${book.img}` : undefined,
        moveToSweepUuid: undefined,
      };
    } else if (!isChapterLocked(chapterId)) {
      const chapter = book.chapters.find((x) => x.id === chapterId);
      data = {
        title: chapter.title,
        description: chapter.description,
        url: chapter.img ? `${process.env.REACT_APP_AWS}/games/${book.gameId}/book/${book.id}/chapter/${chapter.id}/${chapter.img}` : undefined,
        moveToSweepUuid: chapter.sweepUuid,
      };
    }

    if (data) {
      setActiveData(data);
    }
  };

  useEffect(() => {
    if (activeData && !activeData.url) {
      if (activeData.moveToSweepUuid) {
        moveToSweep(activeData.moveToSweepUuid);
      }
      setActiveData(undefined);
      onClose();
    }
  }, [activeData]);

  return (
    <>
      <BannerHorizontalViewOnly show={show} onClose={onClose} />
      <Root background={backgroundColor} opacity={backgroundOpacity} color={textColor}>
        <Header>
          <h2>{book?.description || translation?.expJournBook || 'Journey book'}</h2>
          <Icon.Close onClick={onClose} />
        </Header>
        <List buttonColor={buttonColor} color={textColor}>
          <li key="0" className="chapter" onClick={() => openChapter(0)}>
            {translation?.experienceCover || 'Cover'}
          </li>
          {sortBy(book.chapters || [], 'order').map((chapter) => (
            <li className="d-flex justify-content-between align-center chapter" key={chapter.id} onClick={() => openChapter(chapter.id)}>
              {chapter.title}
              {isChapterLocked(chapter.id) && <Icon.Lock fontSize="inherit" />}
            </li>
          ))}
        </List>

        <ChapterDetails book={book} chapter={activeData} onClose={() => setActiveData(undefined)} moveToSweep={moveToSweep} />
      </Root>
    </>
  );
};
